module.exports = "ul {\n    list-style-type: none;\n  }\n\n.suggestion-search-msg {\n    padding: 15px;\n}\n.suggestion-search-msg>a {\n    color: #fff;\n}\n.suggestions {\n    z-index: 100;\n    background-color: #000;\n    float: right;\n    position: absolute;\n    padding: 10px;\n    opacity: 0.9\n}\n@media screen and (max-width: 9200px) {\n    .suggestions { width: 545px}\n}\n@media screen and (max-width: 576px) {\n    .suggestions { width: 250px}\n}\n.suggestions>div>ul>li>a {\n    color: #ddd;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/assets/css/search.css
// module id = 502
// module chunks = 0